// ============================================================
// Google Translate <-> React DOM safety patch
// ------------------------------------------------------------
// Google Translate rewrites text nodes inside React-managed DOM
// (it swaps a text node for a <font> wrapper). When React later
// tries to remove/replace that original node it throws:
//   NotFoundError: Failed to execute 'removeChild' on 'Node'
//
// The standard, widely used fix is to make removeChild/insertBefore
// resilient: if the node isn't actually a child of `this`, fall back
// to removing it from its real parent (or appending) instead of
// throwing. Must run before React renders — imported first in
// src/index.js.
// ============================================================

if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function patchedRemoveChild(child) {
    if (child && child.parentNode !== this) {
      if (child.parentNode) {
        try {
          return originalRemoveChild.call(child.parentNode, child);
        } catch {
          return child;
        }
      }
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function patchedInsertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (newNode) {
        try {
          return this.appendChild(newNode);
        } catch {
          return newNode;
        }
      }
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}

const domPatch = null;

export default domPatch;
